import sessionLimitConfig from '@customer/config/sessionLimit.config';
import { getBaseDomain } from '@customer/utils/helpers';

import { GetSessions as CustomerSessions } from '@customer/types/loginApiActions';
import Cookie from 'cookie-universal';

const SESSIONS_COOKIE_NAME = 'loginSessions';

export const getSessionsCookie = () => {
  let cookies = null;

  if (typeof window !== 'undefined') {
    cookies = Cookie();
  }

  return cookies ? cookies.get(SESSIONS_COOKIE_NAME) || null : null;
};

const setSessionsCookie = () => {
  let cookies = null;

  if (typeof window !== 'undefined') {
    cookies = Cookie();
  }

  if (cookies) {
    const now = new Date();
    const options = {
      domain: getBaseDomain(),
      path: '/',
      expires: new Date(now.setHours(now.getHours() + 12)),
    };

    cookies.set(SESSIONS_COOKIE_NAME, 1, options);
  }
};

export const getCustomerActiveSessionsNumber = (sessions: CustomerSessions) => {
  const { data } = sessions;

  if (!data) {
    return 0;
  }

  const activeSessionsCountStartDate = new Date();
  activeSessionsCountStartDate.setHours(activeSessionsCountStartDate.getHours() - sessionLimitConfig.activeSessionsHours);

  const activeSessionsCountStartTime = activeSessionsCountStartDate.getTime();
  const customerSessions = data.items.filter((session) => new Date(session.lastCheck).getTime() > activeSessionsCountStartTime);

  setSessionsCookie();

  return customerSessions.length;
};
